import { useCombobox } from 'downshift';
let idCounter = 0;
const useDownShift = ({ setQuery, items, onSubmit, cioClient, previousQuery = '' }) => useCombobox({
    id: `cio-autocomplete-${idCounter++}`,
    items,
    itemToString: (item) => item?.value || '',
    onSelectedItemChange({ selectedItem }) {
        if (selectedItem) {
            setQuery(selectedItem.value || '');
            if (selectedItem?.value) {
                if (onSubmit)
                    onSubmit({ item: selectedItem, originalQuery: previousQuery });
                try {
                    if (!selectedItem?.data?.url) {
                        cioClient?.tracker.trackSearchSubmit(selectedItem.value, {
                            originalQuery: previousQuery,
                        });
                    }
                    cioClient?.tracker.trackAutocompleteSelect(selectedItem.value, {
                        originalQuery: previousQuery,
                        section: selectedItem.section,
                    });
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }
            }
        }
    },
});
export default useDownShift;
